import { SearchStoreService } from '@ecs-services/search/search-store.service';
import { ActionCreator, ReducerTypes } from '@ngrx/store';
import { skip } from 'rxjs';

// type needs to be extracted as it is no longer public as of Version20
export type OnReducer<State, Creators extends readonly ActionCreator[]> = ReducerTypes<
    State,
    Creators
>['reducer'];

export const prefixed = (prefix: string, text: string) => `${prefix} ${text}`;

export const reducerFilter =
    <State, FilteredState, Creators extends readonly ActionCreator[]>(
        filter: (state: State | FilteredState) => state is FilteredState,
        reducer: OnReducer<FilteredState, Creators>
    ): OnReducer<State | FilteredState, Creators> =>
    (state: State | FilteredState, action) => {
        if (!filter(state)) {
            return state;
        }

        return reducer(state, action);
    };

/**
 * Observable that emits when the searchterm changed.
 * The emit tells the caller to complete his observable.
 * This prevents calls from previous search result to execute again, due to
 * outer observables calling it e.g. language change or user change in interceptor
 *
 * @see {@link OsApiAuthInterceptor} subscribes to loginService.loggedIn and retriggers api calls
 * @see Helpline #20230606-0735 or Azure-Ticket #510921: OsApiAuthInterceptor retriggers api calls for previous search results due to outer subscription of loginService.loggedIn
 *
 * @param searchStore searchStore
 * @returns observable that tells when it's time to complete
 */
export const searchTermChanged = (searchStore: SearchStoreService) =>
    searchStore.getSearchTerm().pipe(skip(1));
